const RenderModal = ({ Component, show, ...rest }) => {
  return show ? <Component {...rest} /> : null;
};

export default RenderModal;
